<template>
    <div class="weapon-page">
        <gameInfoTitle title="武器資訊"></gameInfoTitle>
        <div class="weapon-detail">
            <switchBar :barData="barData" type="pullDown" @changeTab="changeTab"></switchBar>
            <table class="weapon-grid">
                <tr class="weapon-grid-cell">
                    <td class="weapon-grid-cellImg" colspan="2">
                        <div class="img-wrap">
                            <gameObjCard :type="3" :hasName="false" :src="detailData.liveSrc" :quality="detailData.quality">
                            </gameObjCard>
                        </div>

                    </td>
                </tr>
                <tr class="weapon-grid-cell">
                    <td class="weapon-grid-cellNormal" colspan="2">
                        <div class="text-cell-wrap">
                            <div class="text-cell">
                                <p class="text-cell1">名稱:</p>
                                <p class="text-cell2">{{ currentData.name || '-' }}</p>
                            </div>
                            <div class="text-cell">
                                <p class="text-cell1">類型:</p>
                                <p class="text-cell2">{{ currentData.weaponType | weaponTypeFilter }}</p>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr class="weapon-grid-cell">
                    <td class="weapon-grid-cellNormal" colspan="2">
                        <div class="text-cell-wrap">
                            <div class="text-cell">
                                <p class="text-cell1">等級:</p>
                                <p class="text-cell2">{{ currentData.weaponLevel || '-' }}</p>
                            </div>
                            <div class="text-cell">
                                <p class="text-cell1">裝配位置:</p>
                                <p class="text-cell2">{{ currentData.weaponPosition | weponPositionFilter }}</p>
                            </div>
                        </div>

                    </td>
                </tr>
                <tr class="weapon-grid-cell">
                    <td class="weapon-grid-cellNormal" colspan="2">
                        <div class="text-cell-wrap">
                            <div class="text-cell">
                                <p class="text-cell1">品質:</p>
                                <p class="text-cell2">{{ currentData.weaponQuality || '-' }}</p>
                            </div>
                            <div class="text-cell">
                                <p class="text-cell1">命中:</p>
                                <p class="text-cell2">{{ currentData.hit || '-' }}</p>
                            </div>
                        </div>

                    </td>
                </tr>
                <tr class="weapon-grid-cell">
                    <td class="weapon-grid-cellNormal" colspan="2">
                        <div class="text-cell-wrap">
                            <div class="text-cell">
                                <p class="text-cell1">攻擊:</p>
                                <p class="text-cell2">{{ currentData.attack || '-' }}</p>
                            </div>
                            <div class="text-cell">
                                <p class="text-cell1">{{ gridType == 'type2' ? '盾牌耐久:' : '暴擊:' }}</p>
                                <p class="text-cell2">{{ gridType == 'type2' ? currentData.shieldDurability || '-' :
                                    currentData.weakPoint || '-' }}
                                </p>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr class="weapon-grid-cell">
                    <td class="weapon-grid-cellNormal" colspan="2">
                        <div class="text-cell-wrap">
                            <div class="text-cell">
                                <p class="text-cell1">射程:</p>
                                <p class="text-cell2">{{ currentData.gunshot || '-' }}</p>
                            </div>
                            <div class="text-cell">
                                <p class="text-cell1">重量:</p>
                                <p class="text-cell2">{{ currentData.weight || '-' }}</p>
                            </div>
                        </div>

                    </td>
                </tr>
                <tr class="weapon-grid-cell" v-if="gridType == 'type3'">
                    <td class="weapon-grid-cellNormal" colspan="2">
                        <div class="text-cell-wrap">
                            <div class="text-cell">
                                <p class="text-cell1">彈量:</p>
                                <p class="text-cell2">{{ currentData.bombLoad || '-' }}</p>
                            </div>
                            <!-- <div class="text-cell">
                                <p class="text-cell1">冷卻:</p>
                                <p class="text-cell2">{{ currentData.reload || '-' }}</p>
                            </div> -->
                        </div>
                    </td>
                </tr>
                <tbody v-for="item in currentData.skill">
                    <tr class="weapon-grid-cellSkill">
                    <td class="skill-info-icon" rowspan="2">
                        <div class="skill-icon">
                            <img :src="item.skillIcon" />
                        </div>
                    </td>
                    <td class="skill-info-attr">
                        <div class="text-cell-wrap">
                            <div class="text-cell">
                                <p class="text-cell1">{{ item.skillType}}</p>
                            </div>
                            <div class="text-cell">
                                <p class="text-cell1">消耗:</p>
                                <p class="text-cell2">{{ item.skillExpend }}</p>
                            </div>
                            <div class="text-cell">
                                <p class="text-cell1">冷卻:</p>
                                <p class="text-cell2">{{ item.skillCd }}</p>
                            </div>
                        </div>
                    </td>
                    </tr>
                    <tr class="weapon-grid-cellSkill2">
                        <td class="skill-info-desc">
                            <div class="text-cell-wrap">
                                <div class="text-cell1">
                                    <p>{{ item.skillName }}</p>
                                </div>
                                <div class="text-cell2">
                                    <p v-html="item.skillDesc"></p>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>

                <!-- <tr class="weapon-grid-cellSkill" v-if="currentData.skill && currentData.skill.length > 1">
                    <td class="skill-info-icon" rowspan="2">
                        <div class="skill-icon">
                            <img
                                :src="currentData.skill && currentData.skill.length > 1 ? currentData.skill[1].skillIcon : ''" />
                        </div>
                    </td>
                    <td class="skill-info-attr">
                        <div class="text-cell-wrap">
                            <div class="text-cell">
                                <p class="text-cell1">{{ currentData.skill && currentData.skill.length > 1 ?
                                    currentData.skill[1].skillType : '-' }}</p>
                            </div>
                            <div class="text-cell">
                                <p class="text-cell1">消耗:</p>
                                <p class="text-cell2">{{ currentData.skill && currentData.skill.length > 1 ?
                                    currentData.skill[1].skillExpend : '-' }}</p>
                            </div>
                            <div class="text-cell">
                                <p class="text-cell1">冷卻:</p>
                                <p class="text-cell2">{{ currentData.skill && currentData.skill.length > 1 ?
                                    currentData.skill[1].skillCd : '-' }}</p>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr class="weapon-grid-cellSkill2" v-if="currentData.skill && currentData.skill.length > 1">
                    <td class="skill-info-desc">
                        <div class="text-cell-wrap">
                            <div class="text-cell1">
                                <p>{{ currentData.skill && currentData.skill.length > 1 ?
                                    currentData.skill[1].skillName : '-' }}</p>
                            </div>
                            <div class="text-cell2">
                                <p v-html="currentData.skill && currentData.skill.length > 1 ?
                                    currentData.skill[1].skillDesc : '-'"></p>
                            </div>
                        </div>
                    </td>
                </tr> -->
            </table>
        </div>
        <div class="weapon-desc">
            <div class="weapon-desc-grid">
                <div class="weapon-desc-grid-cell1">
                    <p>獲取方式</p>
                </div>
                <div class="weapon-desc-grid-cell2">
                    <p>{{ detailData.gain || '-' }}</p>
                </div>
                <div class="weapon-desc-grid-cell3">
                    <p>相關描述</p>
                </div>
                <div class="weapon-desc-grid-cell4">
                    <p>{{ detailData.desc || '-' }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import gameInfoTitle from '../components/gameInfoTitle.vue';
import switchBar from '../components/base/switchBar.vue';
import gameObjCard from '../components/base/gameObjCard.vue';
export default {
    components: { gameInfoTitle, switchBar, gameObjCard },
    props: {
        detailData: {
            type: Object,
            required: true
        }
    },
    filters: {
        weaponTypeFilter(val) {
            switch (val) {
                case 'Knuckle':
                    return '拳套'
                case 'PileBunker':
                    return '打樁機'
                case 'Rod':
                    return '長柄'
                case 'Buckler':
                    return '手盾'
                case 'MachineGun':
                    return '機槍'
                case 'HeavyMachineGun':
                    return '重機槍'
                case 'ShotGun':
                    return '霰彈槍'
                case 'LightSniper':
                    return '輕型步槍'
                case 'HeavySniper':
                    return '狙擊步槍'
                case 'Shield':
                    return '大盾'
                case 'Rocket':
                    return '火箭'
                case 'Missile':
                    return '導彈'
                case 'RailGun':
                    return '電磁炮'
                case 'Flamethrower':
                    return '噴火器'
                default:
                    return val
            }
        },
        weponPositionFilter(val) {
            switch (val) {
                case 'Hand':
                    return '手持'
                case 'DoubleHand':
                    return '雙手'
                case 'Back':
                    return '背部'
                case 'Shoulder':
                    return '肩部'
                default:
                    return val
            }
        }
    },
    data() {
        return {
            currentIndex: 0,
        }
    },
    methods: {
        changeTab(index) {
            this.currentIndex = index;
        }
    },
    watch: {
        // detailData(val) {
        //     if (val.weaponData.length > 0) {
        //         this.currentIndex = val.weaponData[0].weaponLevel
        //     }
        // }
    },
    computed: {
        barData() {
            if (!this.detailData || !this.detailData.weaponData || this.detailData.weaponData.length == 0) {
                return []
            }
            return this.detailData.weaponData.map((item,index) => {
                if (item.weaponLevel) {
                    return {
                        title: `${item.weaponLevel}级`,
                        cb: index
                    }
                } else {
                    return null
                }
            })
        },
        currentData() {
            if (!this.detailData) {
                return {}
            } else {
                if (!this.detailData.weaponData) {
                    return {}
                } else if (this.detailData.weaponData.length == 0) {
                    return {}
                } else {
                    return this.detailData.weaponData[this.currentIndex] || {}
                }
            }
        },
        gridType() {
            let type2 = ['Buckler', 'Shield']
            let type3 = ['Rocket', 'Missile', 'RailGun']
            if (type2.includes(this.detailData.type)) {
                return 'type2'
            } else if (type3.includes(this.detailData.type)) {
                return 'type3'
            } else {
                return 'type1'
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.weapon-page {

    .weapon-detail {
        margin-top: .12rem;

        .weapon-grid {
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0;
            margin-top: .01rem;
            margin-bottom: .3rem;

            &-cellImg {
                width: 100%;
                height: 1.6rem;
                border-color: black;
                border-style: solid;
                border-width: 1px;

                .img-wrap {
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }

            &-cell:nth-child(odd) {
                background-color: #f2f2f4;
            }

            &-cellNormal,
            &-cellSkill,
            &-cellSkill2 {
                border-color: black;
                border-style: solid;
                border-width: 1px;

                .text-cell-wrap {
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .text-cell {
                        flex: 1;
                        padding: 0 .2rem;
                        display: flex;
                        font-size: .22rem;
                        align-items: center;
                        justify-content: center;
                        line-height: .48rem;
                    }

                    .text-cell1 {
                        font-weight: 600;
                        margin-right: .2rem;
                    }

                    .text-cell2 {
                        flex: 1;
                        color: #404040;
                    }
                }


            }

            &-cellNormal {
                height: .55rem;
            }

            &-cellSkill {
                height: .55rem;

                .skill-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 1.06rem;
                        height: 1.06rem;
                        object-fit: contain;
                    }
                }

                .skill-info-icon {
                    border-color: black;
                    border-style: solid;
                    border-width: 1px;
                }

                .skill-info-attr {
                    height: .55rem;
                }
                .text-cell1 {
                    font-size: .24rem;
                }
                .text-cell2 {
                    font-size: .22rem;
                }


            }

            &-cellSkill2 {
                height: 1.22rem;

                .skill-info-desc {
                    padding: .22rem;
                    background-color: #f2f2f4;
                }
                .text-cell1 {
                    font-size: .24rem;
                }
                .text-cell2 {
                    font-size: .22rem;
                }
            }
        }
    }

    .weapon-desc {
        width: 100%;

        .weapon-desc-grid {
            display: grid;
            height: 2.3rem;
            border: .01rem solid #d2d5da;
            grid-template-rows: repeat(5, 1fr);
            grid-template-areas: "cell1"
                "cell2"
                "cell3"
                "cell4"
                "cell4";

            &-cell1 {
                display: flex;
                align-items: center;
                justify-content: center;
                grid-area: cell1;
                background-color: #d2d5da;
                padding: 0 .2rem;

                p {
                    font-size: .24rem;
                    font-weight: bold;
                }
            }

            &-cell2 {
                grid-area: cell2;
                display: flex;
                align-items: center;
                justify-content: center;

                p {
                    color: #404040;
                    font-size: .22rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: break-word;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                }

                background-color: white;
                padding: 0 .2rem;

            }

            &-cell3 {
                display: flex;
                align-items: center;
                justify-content: center;

                p {
                    font-weight: bold;
                    font-size: .24rem;
                }

                grid-area: cell3;
                background-color: #d2d5da;
                padding: 0 .2rem;
            }

            &-cell4 {
                p {
                    color: #404040;
                    font-size: .22rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: break-word;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }

                display: flex;
                align-items:center;
                justify-content:center;
                grid-area: cell4;
                background-color: white;
                padding: 0 .2rem;

            }
        }
    }
}
</style>